import { TransferOrderDetailPage } from "@/features/transfer-order/pages/TransferOrderDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/transfer-order/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["transfer_order.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferOrderDetailPage,
});
